module.exports = __webpack_public_path__ + "static/media/ambassador-second.16f0bf2a.jpg";